/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteTestExecutionCommentType } from "./QuoteTestExecutionCommentType";
import {
  QuoteTestExecutionCommentTypeFromJSON,
  QuoteTestExecutionCommentTypeFromJSONTyped,
  QuoteTestExecutionCommentTypeToJSON,
  QuoteTestExecutionCommentTypeToJSONTyped,
} from "./QuoteTestExecutionCommentType";

/**
 *
 * @export
 * @interface PostQuoteTestExecutionCommentBody
 */
export interface PostQuoteTestExecutionCommentBody {
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  executionId: string;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  expectationId?: string | null;
  /**
   *
   * @type {QuoteTestExecutionCommentType}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  type: QuoteTestExecutionCommentType;
  /**
   *
   * @type {boolean}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  isResolved: boolean;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  text: string;
  /**
   *
   * @type {boolean}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  isPinned: boolean;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestExecutionCommentBody
   */
  replyTo?: string | null;
}

/**
 * Check if a given object implements the PostQuoteTestExecutionCommentBody interface.
 */
export function instanceOfPostQuoteTestExecutionCommentBody(
  value: object,
): value is PostQuoteTestExecutionCommentBody {
  if (!("executionId" in value) || value["executionId"] === undefined)
    return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("isResolved" in value) || value["isResolved"] === undefined)
    return false;
  if (!("text" in value) || value["text"] === undefined) return false;
  if (!("isPinned" in value) || value["isPinned"] === undefined) return false;
  return true;
}

export function PostQuoteTestExecutionCommentBodyFromJSON(
  json: any,
): PostQuoteTestExecutionCommentBody {
  return PostQuoteTestExecutionCommentBodyFromJSONTyped(json, false);
}

export function PostQuoteTestExecutionCommentBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PostQuoteTestExecutionCommentBody {
  if (json == null) {
    return json;
  }
  return {
    executionId: json["executionId"],
    expectationId:
      json["expectationId"] == null ? undefined : json["expectationId"],
    type: QuoteTestExecutionCommentTypeFromJSON(json["type"]),
    isResolved: json["isResolved"],
    text: json["text"],
    isPinned: json["isPinned"],
    replyTo: json["replyTo"] == null ? undefined : json["replyTo"],
  };
}

export function PostQuoteTestExecutionCommentBodyToJSON(
  json: any,
): PostQuoteTestExecutionCommentBody {
  return PostQuoteTestExecutionCommentBodyToJSONTyped(json, false);
}

export function PostQuoteTestExecutionCommentBodyToJSONTyped(
  value?: PostQuoteTestExecutionCommentBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    executionId: value["executionId"],
    expectationId: value["expectationId"],
    type: QuoteTestExecutionCommentTypeToJSON(value["type"]),
    isResolved: value["isResolved"],
    text: value["text"],
    isPinned: value["isPinned"],
    replyTo: value["replyTo"],
  };
}
